import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { SignalSection } from '../components/SignalSection';
import { DifferenceSection } from '../components/DifferenceSection';
import { PainSection } from '../components/PainSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BibliotecaSection } from '../components/BibliotecaSection';
import { OfferSection } from '../components/OfferSection';
import { AboutSection } from '../components/AboutSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
export function LandingPage() {
  return <main className="overflow-hidden bg-background text-foreground min-h-screen font-body" data-id="element-225">
      <HeroSection data-id="element-226" />
      <SignalSection data-id="element-227" />
      <DifferenceSection data-id="element-228" />

<PainSection data-id="element-229" />
<BenefitsSection data-id="element-230" />

<ProtocolSection data-id="element-231" />

<ForWhoSection data-id="element-232" />

<TestimonialsSection data-id="element-233" />

      <BibliotecaSection data-id="element-234" />

      <OfferSection data-id="element-235" />
      <AboutSection data-id="element-236" />
      <FAQSection data-id="element-237" />
      <FinalCTASection data-id="element-238" />
    </main>;
}